module.exports = __webpack_public_path__ + "static/media/cardIconOccurrences.11593a56.svg";